import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-center/lang/index';
import { getVisitorExport } from '@blade-sxp/portrait-center/api/index';
import { dateFormat } from '@blade/common/utils/filters';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
import { PortraitCenterModule } from '@blade-sxp/portrait-center/store/index';
import SecondaryVerification from '@blade/common/pages/Secondary-verification/secondary-verification.vue';
import { SYSTEMCODE } from '@blade/common/constants/code';
import { getFuncVisitorPagelist } from '@blade-sxp/portrait-center/utils/common-request';
let default_1 = class default_1 extends Vue {
    dates;
    zoneType;
    fullSkDialogVisible = false;
    isLoading = false;
    permissionlevel = permissionlevel;
    SYSTEMCODE = SYSTEMCODE;
    tableData = [];
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    helpText = '';
    get clusterType() {
        return PortraitCenterModule.clusterType;
    }
    get activeTab() {
        return PortraitCenterModule.activeTab;
    }
    get zoneId() {
        return PortraitCenterModule.zoneId;
    }
    get sourceType() {
        let value = '';
        if (this.zoneType === 'MAP') {
            value = 'VISIT_USER_COUNT';
        }
        else if (this.zoneType === 'VIRTUAL_AREA') {
            value = 'VA_VISIT_USER_COUNT';
        }
        return value;
    }
    getHelpText() {
        this.helpText = `${this.clusterType === 'offline' ? this.$t('clusterTypeYear') : this.$t('clusterTypeDays')}`;
    }
    onChangeDates() {
        this.onResearch();
    }
    onChangeZoneId() {
        this.onResearch();
    }
    mounted() {
        this.onResearch();
    }
    onResearch() {
        if (this.zoneId === 0) {
            this.tableData = [];
            return false;
        }
        this.pagination.page = 1;
        this.tableData = [];
        this.$nextTick(() => {
            this.fetchData();
        });
    }
    fetchData() {
        this.isLoading = true;
        const { page, size } = this.pagination;
        getFuncVisitorPagelist({
            businessId: this.zoneId,
            dateStart: this.dates[0],
            dateEnd: this.dates[1],
            // pageOrderList: [],
            sourceType: this.sourceType,
            page,
            size,
            zoneType: this.zoneType,
        })
            .then((res) => {
            this.tableData = res.list;
            this.pagination.page = res.page;
            this.pagination.total = res.total;
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        })
            .finally(() => {
            this.isLoading = false;
        });
    }
    handleSizeChange(size) {
        this.pagination.size = size;
        this.pagination.page = 1;
        this.fetchData();
    }
    handleCurrentChange(page) {
        this.pagination.page = page;
        this.fetchData();
    }
    handleExportVisitors() {
        this.fullSkDialogVisible = true;
    }
    handleExport() {
        this.exportData(getVisitorExport);
    }
    async exportData(apiFuc) {
        if (!apiFuc)
            return;
        const requestBody = {
            dateStart: dateFormat(this.dates[0], 'YYYY-MM-DD') || '',
            dateEnd: dateFormat(this.dates[1], 'YYYY-MM-DD') || '',
            businessId: this.zoneId,
            sourceType: this.sourceType,
            zoneType: this.zoneType,
        };
        try {
            const resp = await apiFuc(requestBody);
            const data = resp || '';
            window.location.href = process.env.NODE_ENV === 'development' ? `${data}` : data;
        }
        catch (err) {
            // this.$message.error(err?.message || `${this.$t('common.serverError')}`);
        }
    }
    getIdentity(val) {
        let newVal = val;
        // switch (val) {
        //   case 'Anonymous':
        //     newVal = '';// 非实名
        //     break;
        //   case 'Real-name':
        //     newVal = ''; // 实名
        //     break;
        // }
        return newVal;
    }
    getGender(val) {
        let newVal = val;
        // switch (val) {
        //   case 'MALE':
        //     newVal = '';
        //     break;
        //   case 'Female':
        //     newVal = '';
        //     break;
        // }
        return newVal;
    }
    getAge(val) {
        let newVal = val;
        // switch (val) {
        //   case 'ST_CHILD':
        //     newVal = '';
        //     break;
        //   case '':
        //     newVal = '';
        //     break;
        // }
        return newVal;
    }
};
__decorate([
    Prop()
], default_1.prototype, "dates", void 0);
__decorate([
    Prop()
], default_1.prototype, "zoneType", void 0);
__decorate([
    Watch('clusterType', { immediate: true })
], default_1.prototype, "getHelpText", null);
__decorate([
    Watch('dates')
], default_1.prototype, "onChangeDates", null);
__decorate([
    Watch('zoneId')
], default_1.prototype, "onChangeZoneId", null);
default_1 = __decorate([
    Component({
        name: 'export-table',
        components: {
            AuthNewitem,
            'secondary-verification': SecondaryVerification,
        },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
